// extracted by mini-css-extract-plugin
module.exports = {"contents":"En-z","sectionHeading":"Fn-z"};